import React, { useContext } from "react"
import { Modal } from "react-bootstrap";
import { Autocomplete, Button, InputLabel, TextField, MenuItem, Select } from "@mui/material";
import language from "../../../nls/language.json";
import Context from "../../../context/Context";
import '../Combinations.css';

export default function EditProductModal({
  ShowModalEdit,
  setShowModalEdit,
  handleAddProducts,
  selectedProduct,
  grupoProdutos,
  produtosOptions,
  putProducts,
  checkSaveBtn
}) {
  const {
    selectedCountry,
  } = useContext(Context);

  return (
    <Modal size="lg" show={ShowModalEdit} onHide={() => setShowModalEdit(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.editarProduto.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 py-3">
        <div className="d-flex flex-row gap-3">
          <div className="d-flex flex-column w-50">
            <InputLabel sx={{ fontSize: '0.95rem', fontWeight: 600, mb: 1 }}>
              {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.editarProduto.labels.produto}
            </InputLabel>
            <Autocomplete
              options={produtosOptions}
              getOptionLabel={(opt) => `${opt.descricao} (${opt.valor})`}
              filterOptions={(opts, { inputValue }) =>
                opts.filter(o =>
                  o.descricao.toLowerCase().includes(inputValue.toLowerCase()) ||
                  o.valor.toLowerCase().includes(inputValue.toLowerCase())
                )
              }
              value={produtosOptions.find(o => o.valor === selectedProduct.prodGrupo_ProdCod) ?? null}
              onChange={(_, opt) => handleAddProducts({ name: "prodGrupo_ProdCod", value: opt?.valor ?? "" }, "EDIT_PRODUTO")}
              renderInput={(params) => (
                <TextField {...params} required fullWidth placeholder="Selecione o Produto" />
              )}
            />
          </div>

          <div className="d-flex flex-column w-50">
            <InputLabel sx={{ fontSize: '0.95rem', fontWeight: 600, mb: 1 }}>
              {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.editarProduto.labels.grupo}
            </InputLabel>
            <Select
              value={selectedProduct.prodGrupo_GrupoNome}
              onChange={({ target }) => {
                handleAddProducts({ name: "prodGrupo_GrupoNome", value: target.value }, "EDIT_PRODUTO")
              }}
            >
              {grupoProdutos.map((itemProd, i) => (
                <MenuItem
                  key={`grupProd-${itemProd.prodGrupo_GrupoNome}-${i}`}
                  value={itemProd.prodGrupo_GrupoNome}
                >
                  {itemProd.prodGrupo_GrupoNome}
                </MenuItem>
              ))}
            </Select>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="text"
          sx={{ marginRight: 2 }}
          onClick={() => setShowModalEdit(false)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.editarProduto.btnCancelar}
        </Button>
        <Button
          variant="contained"
          onClick={() => putProducts(selectedProduct)}
          disabled={checkSaveBtn(selectedProduct)}
        >
          {language[selectedCountry.name].Cadastro.combinacoes.produtos.modal.editarProduto.btnSalvar}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
